import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Dialog from "nx-components/Dialog";
import News from "nexia_mobile/components/News";
import renderInDestroyableRoot from "nexia_mobile/components/Dialogs/renderInDestroyableRoot";

export default class NewsDialog extends React.Component {
  static propTypes = {
    collection: PropTypes.instanceOf(Backbone.Collection).isRequired,
    onCloseDialog: PropTypes.func.isRequired,
  };

  render() {
    const { collection, onCloseDialog } = this.props;

    return (
      <Dialog
        open
        onTapBackground={onCloseDialog}
        onRequestClose={onCloseDialog}
      >
        <News collection={collection} />
      </Dialog>
    );
  }
}

export function showNewsDialog(options) {
  renderInDestroyableRoot((destroyRoot) => {
    const dialogProps = { ...options };

    dialogProps.onCloseDialog = () => {
      if (options.onCloseDialog) {
        options.onCloseDialog();
      }
      destroyRoot();
    };

    return <NewsDialog {...dialogProps} />;
  });
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/NewsDialog.jsx